import { Heading, Icon, Paragraph, TextButton, Upsell } from '@zillow/constellation-10';
import { IconChecklistFilled } from '@zillow/constellation-icons';

import { US_STATES_LABEL_MAP } from '@zg-rentals/states-territories';

import { emitViewGeneratedLeaseEvent, VIEW_GENERATED_LEASE_EVENT_ID } from '../../../../analytics/events/leasesPage';

import { useAuth } from '../../../AuthProvider';

type Props = {
  listingAlias: string;
  state?: string;
};

const GeneratedLeaseUpsell = ({ listingAlias, state: propertyState }: Props) => {
  const { user } = useAuth();

  const handleViewLeaseClick = () => {
    if (user) {
      emitViewGeneratedLeaseEvent({ currentProperty: { listingAlias }, user });
    }
  };

  const stateName = propertyState
    ? US_STATES_LABEL_MAP[propertyState.toUpperCase() as keyof typeof US_STATES_LABEL_MAP] || propertyState
    : 'your state';

  return (
    <Upsell
      data-testid="GeneratedLeaseUpsell"
      tone="soft"
      closeable={false}
      media={
        <Icon>
          <IconChecklistFilled />
        </Icon>
      }
      header={<Heading level={1}>Need a lease agreement?</Heading>}
      body={
        <Paragraph>We’ve created a custom lease for you that includes legal clauses specific to {stateName}.</Paragraph>
      }
      action={
        <TextButton tone="brand" asChild data-eventid={VIEW_GENERATED_LEASE_EVENT_ID}>
          <a href={`/rental-manager/leasing/property/${listingAlias}/generate`} onClick={handleViewLeaseClick}>
            View lease
          </a>
        </TextButton>
      }
      elevated={false}
    />
  );
};

export default GeneratedLeaseUpsell;
